export default "__VITE_PUBLIC_ASSET__e44396c4__"